import React from 'react'
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../../components/SubmitButton";

interface Props {
  title: string;
  validate?: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>;
}

const SubmitButton: React.FC<Props> = ({ title, validate, onSubmit }) => {
  const _validate = async () => validate ? await validate() : true;

  return (
    <Button
      color="secondary"
      sx={styles.button}
      size={"large"}
      variant="outlined"
      validate={_validate}
      onSubmit={onSubmit}
      endIcon={
        <FontAwesomeIcon style={ styles.icon } icon={faChevronRight} />
      }
    >
      {title}
    </Button>
  );
};
export default SubmitButton;

const styles = {
  button: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom: 8,
  },

  icon: {
    position: "absolute" as const,
    top: 0,
    right: 0,
    margin: "10px"
  },
}
